import { Radio } from "antd";
import clsx from "clsx";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import type { Endpoint } from "sandbox/types";

import { CopyButton } from "sandbox/features/shared";
import {
  type CodeLanguage,
  generateCodeSample,
  LANGUAGE_LABELS,
} from "sandbox/utils/codeSamples";
import { AMP_BLOCK_CLASS } from "shell/api/amplitudePrivacy";

import s from "./CodeSamples.module.css";

interface CodeSamplesProps {
  bearerToken?: string;
  body?: string;
  endpoint: Endpoint;
  url: string;
}

const LANGUAGES: CodeLanguage[] = ["curl", "node", "python", "go"];

export const CodeSamples = ({
  endpoint,
  url,
  body,
  bearerToken,
}: CodeSamplesProps) => {
  const { t } = useTranslation("sandbox");
  const [language, setLanguage] = useState<CodeLanguage>("curl");
  const snippet = generateCodeSample(language, {
    endpoint,
    url,
    body,
    bearerToken,
  });

  return (
    <div className={s.root}>
      <Radio.Group
        className={s.languageSelector}
        value={language}
        onChange={e => setLanguage(e.target.value as CodeLanguage)}
      >
        {LANGUAGES.map(l => (
          <Radio.Button key={l} value={l}>
            {LANGUAGE_LABELS[l]}
          </Radio.Button>
        ))}
      </Radio.Group>
      <div className={s.codeWrapper}>
        <CopyButton
          value={snippet}
          label={t("components.codeSamples.copySnippet")}
          size="middle"
          variant="button"
          className={s.copyButton}
        />
        <pre className={clsx(s.code, AMP_BLOCK_CLASS)}>{snippet}</pre>
      </div>
    </div>
  );
};
